import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { APP_ROUTES } from 'src/app/routes/routes.constants'
import { userSlice } from 'src/modules/user'
import { useSelector } from 'store/redux.store'

import { IUserIntentionQualification } from './user-intention-qualification.interfaces'
import { getUserIntentionQualification } from './user-intention-qualification.services'

const ROUTE_EMPTY = ''
const routesWithoutProductFruits = [APP_ROUTES.onboarding, APP_ROUTES.cas.login, ROUTE_EMPTY]

const isBLockRouter = location => {
  const pathNameEmpty = location.pathname === APP_ROUTES.root

  return Boolean(location.search && pathNameEmpty)
}

const useUserIntentionQualification = () => {
  const [productFruitsUserIntentionQualification, setProductFruitsUserIntentionQualification] =
    useState<IUserIntentionQualification | null>(null)
  const { user } = useSelector(state => state)

  const dispatch = useDispatch()

  const location = useLocation()

  const setUserIntentionQualification = async () => {
    const userIntentionQualification = await getUserIntentionQualification()

    if (userIntentionQualification) {
      const profileWithUserIntention = {
        ...user.profile,
        ...userIntentionQualification
      }

      setProductFruitsUserIntentionQualification(userIntentionQualification)

      dispatch(
        userSlice.actions.updateUser({
          profile: profileWithUserIntention
        })
      )
    }
  }

  useEffect(() => {
    const verifyRoutesWithoutProductFruits = routesWithoutProductFruits.includes(location.pathname)

    const hasIntentionName = user?.profile?.intentionName

    if (!verifyRoutesWithoutProductFruits && !hasIntentionName && !isBLockRouter(location)) {
      setUserIntentionQualification()
    }
  }, [location, user.profile?.intentionName])
  return {
    productFruitsUserIntentionQualification
  }
}

export { useUserIntentionQualification }
